import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { ASSETS_ACTION_TYPE } from '../actions';

const initialState = {};

const assetsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case ASSETS_ACTION_TYPE.GET_ASSETS:
        return payload || initialState;

      case ASSETS_ACTION_TYPE.DELETE_ASSET:
        delete draft[meta.assetId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default assetsReducer;
